import _ from 'lodash';

import { Meteor } from 'meteor/meteor';

import moment from 'moment';

import { Reservations } from '../collections/reservations/reservations';

export class SmsManager {

	static notifyProgrammation(reservations, date, pilote, place) {
		let alreadyNotify = [];
		_.each(reservations, (reservation) => {

			/*let message = 'Bonjour. \n\nVotre réservation' + (reservation.id_billet ? ' N°' + reservation.id_billet : ' ') + ' a été programmée le ' + moment(date).format('DD/MM/YYYY à HH:mm') + ' avec le pilote ' + pilote.profile.firstName + '\n\nLe lieu de rendez-vous est : ' + place.name;

			if (place.precision)
				message += '\n\nPrécision sur le lieu de rendez-vous : ' + place.precision;

			message += '\n\nVoir sur Google Maps : https://www.google.fr/maps/search/' + place.name.replace(' ', '+');
			message += '\n\nNuméro du pilote : ' + pilote.profile.phone;*/

			let message = (reservation.id_billet ? ' Billet N°' + reservation.id_billet : ' ') + ' fixé le ' + moment(date).format('DD/MM/YYYY à HH:mm') + ' à ' + place.name;
			message += '\nInfo pilote :' +  pilote.profile.firstName + ' / ' + pilote.profile.phone;

			Reservations.update(reservation._id, { "$set": {pendingSMS: true}});
			reservation.passengers = reservation.getPassengers();
			_.each(reservation.passengers, (passenger) => {
				if(passenger.phone && !_.includes(alreadyNotify, passenger.phone)) {

					//suppresion des espaces et des points.
					let phone = passenger.phone.slice(1);
					phone = phone.replace(' ', '');
					phone = phone.replace('.', '');
					phone = '33' + phone;

					if(phone[2] == '6' || phone[2] == '7') {
						Meteor.call('send.sms', {
							'to': phone,
							'message': message,
							'refID': reservation._id
						});
					}

					alreadyNotify.push(passenger.phone);
				}
			});
		});
	}

	static cancelProgrammation(reservations, date, cause, pilote) {
		let alreadyNotify = [];

		if(!cause) {
			return ;
		}

		_.each(reservations, (reservation) => {

		let message = `Bonjour,

Votre réservation ` + reservation.id_billet + ` a été programmé le ` + moment(date).format('DD/MM/YYYY') + `.

Nous sommes désolés de vous annoncer que celui-ci est annulé car : ` + cause + `.

Vous pouvez à tout moment reprogrammer un vol sur notre site internet à l'adresse suivante http://monvol.montgolfieres.fr

Numéro de billet : ` + reservation.id_billet + `
Mot de passe : ` + moment(reservation.createdAt).format('X').slice(-4) + `

Cordialement, votre pilote ` + pilote.displayName() + `.`;


			Reservations.update(reservation._id, { "$set": {pendingSMS: true}});
			reservation.passengers = reservation.getPassengers();
			_.each(reservation.passengers, (passenger) => {
				if(passenger.phone && !_.includes(alreadyNotify, passenger.phone)) {

					//suppresion des espaces et des points.
					let phone = passenger.phone.slice(1);
					phone = phone.replace(' ', '');
					phone = phone.replace('.', '');
					phone = '33' + phone;

					if(phone[2] == '6' || phone[2] == '7') {
						Meteor.call('send.sms', {
							'to': phone,
							'message': message,
							'refID': reservation._id
						});
					}

					alreadyNotify.push(passenger.phone);
				}
			});
		});
	}

}



/** WEBPACK FOOTER **
 ** ./src/universal/external_api/smsManager.js
 **/